/**
 * Service für Zahlungsanfragen
 * Zentralisiert alle Funktionen rund um das Thema Zahlungsanfragen
 */

import { instance } from '@/services/api/index';

/**
 * Markiert Zahlungsanfragen als gesehen (API-basiert)
 * @returns {Promise<void>}
 */
export const markPaymentRequestsAsSeen = async () => {
  console.log("Zahlungsanfragen als gesehen markiert (lokaler Status)");
  return true;
};

/**
 * Fordert eine Zahlung für eine Session an
 * @param {string} sessionId - ID der Session
 * @returns {Promise<object>} - Antwort vom Server
 */
export const requestPaymentBySession = async (sessionId) => {
  if (!sessionId) {
    throw new Error('Session-ID ist erforderlich');
  }

  console.log(`Fordere Zahlung für Session ${sessionId} an`);
  try {
    const response = await instance.post(`/OrderSessions/${sessionId}/request-payment`);
    return response.data;
  } catch (error) {
    console.error('Fehler beim Anfordern der Zahlung:', error);
    throw error;
  }
};

/**
 * Markiert eine Bestellung als bezahlt
 * @param {string|number} orderId - ID der Bestellung
 * @returns {Promise<object>} - Antwort vom Server
 */
export const markOrderAsPaid = async (orderId) => {
  if (!orderId) {
    throw new Error('Bestellungs-ID ist erforderlich');
  }

  try {
    const response = await instance.post(`/orders/${orderId}/mark-paid`);
    return response.data;
  } catch (error) {
    console.error(`Fehler beim Markieren der Bestellung ${orderId} als bezahlt:`, error);
    throw error;
  }
};

/**
 * Storniert eine Bestellung
 * @param {string|number} orderId - ID der Bestellung
 * @returns {Promise<object>} - Antwort vom Server
 */
export const cancelOrder = async (orderId) => {
  if (!orderId) {
    throw new Error('Bestellungs-ID ist erforderlich');
  }

  try {
    const response = await instance.post(`/orders/${orderId}/cancel`);
    return response.data;
  } catch (error) {
    console.error(`Fehler beim Stornieren der Bestellung ${orderId}:`, error);
    throw error;
  }
};

export const paymentRequestService = {
  markPaymentRequestsAsSeen,
  requestPaymentBySession,
  markOrderAsPaid,
  cancelOrder
}; 